module.exports = __webpack_public_path__ + "img/jsback.80fcb1ee.svg";